// extracted by mini-css-extract-plugin
module.exports = {"outer":"Blimp-module--outer--3Zu3V","canvas":"Blimp-module--canvas--3k-t3"};